import { Outlet } from "react-router-dom";
import WebsiteHeader from "../components/WebsiteHeader";
import WebsiteFooter from "../components/WebsiteFooter";
import WhatsAppButton from "../Website Page/WhatsAppButton";

const PublicLayout = () => (
  <>
    <WebsiteHeader />
    <main>
      <Outlet />
    </main>
    <WebsiteFooter />
    <WhatsAppButton />
  </>
);

export default PublicLayout;
